/**
 * @fileoverview Core module exports for the RAG chatbot system
 * @module core
 *
 * This module provides the foundational infrastructure for the RAG chatbot,
 * including contexts, services, and core utilities.
 */

// API exports
export * from "./api/ChatbotAPI";

// Context exports
export * from "./contexts/ChatbotContext";

// Provider exports
export {
  ChatbotErrorBoundary,
  useChatbotErrorHandler,
} from "./providers/ErrorBoundary";

// Service exports
export * from "./services/llmService";
export * from "./services/vectorStore";
export * from "./services/storageService";

// Re-export key types for convenience
export type {
  ChatbotContextType,
  ChatbotConfig,
  ChatbotError,
  VectorStoreConfig,
  LLMConfig,
  StorageConfig,
  Document,
  Conversation,
  ConversationMessage,
} from "./contexts";

export { ChatbotStatus, VectorStoreType, LLMProvider } from "./contexts";
